import React, { useEffect, useMemo, useState } from 'react';
import { useCommonStyles } from '../../Styles';
import { makeStyles, useTheme } from '@material-ui/core/styles';
// import RoomIcon from '@material-ui/icons/Room';
import { BottomNavigation, BottomNavigationAction, Chip, DialogContent, Tab, Tabs } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
// import ReactMapboxGl, {Layer, Marker, Popup, Source, ZoomControl} from 'react-mapbox-gl';
// import {pure} from 'recompose';
// import 'mapbox-gl/dist/mapbox-gl.css';
import { GoogleMap, useJsApiLoader, Marker, InfoWindow, OverlayView } from '@react-google-maps/api';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import RoomIcon from '@material-ui/icons/Room';
import PublicIcon from '@material-ui/icons/Public';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';
import IconButton from "@material-ui/core/IconButton";
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import {
	// mapbox_key,
	no_image,
	req_cust_approve,
	req_module_setting,
	req_salesman_location,
	req_checkin_stocktake,
	req_checkin_stocktransfer,
	req_checkin_images,
	req_checkin_uploadimage,
	req_stock_take_status,
	req_stock_transfer_status,
	req_gallery_rotateimage,
	req_gallery_type2
} from '../../Helper/Constants';
import moment from 'moment';
import JString from '@easytech-international-sdn-bhd/jstring';
import { usePaperStyles } from '../../Styles/StylePaper';
import MediaBox from '../MediaBox';
import Tooltip from "@material-ui/core/Tooltip";
import API_Service, { axiosURIencode } from '../../Services/API_Service';
import { lineString, point, distance } from '@turf/turf';
import MUIDataTable from 'mui-datatables';
import DoneIcon from '@material-ui/icons/Done';
import SendIcon from '@material-ui/icons/Send';
import DeleteIcon from '@material-ui/icons/Delete';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import RotateLeftIcon from '@material-ui/icons/RotateLeft';
import RotateRightIcon from '@material-ui/icons/RotateRight';
import AddPhotoAlternateIcon from '@material-ui/icons/AddPhotoAlternate';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import Collapse from '@material-ui/core/Collapse';
import VirtualListHierarchical from '../VirtualListHierarchical';
import StockTakeDetails from '../../Components/StockTakeDetails';
import { de, getSetting, arrayBufferToBase64 } from '../../Helper/Helper';
import _ from 'lodash';
import StockTransferDetails from '../StockTransferDetails';
import ReactImageMagnify from 'react-image-magnify';
import VirtualList from '../VirtualList';

const useStyles = makeStyles((theme) => ({
	row: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center'
	},
	large_image: {
		minWidth: 800,
		maxHeight: 450
	},
	large_image2: {
		maxWidth: 400,
		maxHeight: 450
	},
	image: {
		maxWidth: 150,
		marginLeft: 10
	},
	card: {
		maxWidth: 200,
		minWidth: 200,
		marginRight: theme.spacing(1),
		marginTop: theme.spacing(1),
	},
	cardChosen: {
		maxWidth: 200,
		minWidth: 200,
		marginRight: theme.spacing(1),
		marginTop: theme.spacing(1),
		backgroundColor: theme.palette.secondary.light
	},
	appBar: {
		position: 'relative',
	},
	saveBtn: {
		marginTop: theme.spacing(2),
	},
	input: {
		marginTop: theme.spacing(2),
		width: '100%'
	},
	title: {
		marginLeft: theme.spacing(2),
		flex: 1,
	},
	heading: {
		fontSize: theme.typography.pxToRem(15),
		fontWeight: theme.typography.fontWeightMedium,
	},
	viewInRow: {
		display: 'flex',
		flexWrap: 'wrap',
	},
	root: {
		flexGrow: 1,
	},
	paper: {
		padding: theme.spacing(3),
		textAlign: 'flex-start',
		color: theme.palette.text.secondary,
		zIndex: theme.zIndex + 1,
		borderRadius: 16,
		boxShadow: theme.palette.type === 'dark'
			? '0 2px 16px rgba(0,0,0,0.35)'
			: '0 2px 12px rgba(0,0,0,0.08)',
	},
	grid: {
		padding: theme.spacing(2),
		paddingBottom: theme.spacing(5),
	},
	textleft: {
		textAlign: "left"
	},
	maxImage: {
		maxWidth: 250,
		maxHeight: 280
	},
	marginTop: {
		marginTop: theme.spacing(1)
	},
	chooseButton: {
		width: '100%',
		height: theme.spacing(5),
		justifyContent: 'left',
		marginTop: theme.spacing(1)
	},
	image_title: {
		textAlign: 'center',
		fontSize: 16,
		color: "black"
	},
	image_desc: {
		textAlign: 'center',
		fontSize: 14,
		color: "grey"
	},
	fullWidthCard: {
		width: '100%',
		marginBottom: theme.spacing(1)
	},
	// â”€â”€ çŽ°ä»£åŒ–æ–°å¢žæ ·å¼ â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
	sectionHeader: {
		display: 'flex',
		alignItems: 'center',
		marginBottom: theme.spacing(2.5),
		paddingBottom: theme.spacing(1.5),
		borderBottom: `2px solid ${theme.palette.type === 'dark' ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.06)'}`,
	},
	sectionAccent: {
		width: 4,
		height: 22,
		backgroundColor: '#FEF200',
		borderRadius: 2,
		marginRight: theme.spacing(1.5),
		flexShrink: 0,
	},
	sectionTitle: {
		fontSize: 15,
		fontWeight: 700,
		letterSpacing: '0.04em',
		textTransform: 'uppercase',
		color: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.85)' : 'rgba(0,0,0,0.75)',
	},
	sectionBadge: {
		marginLeft: theme.spacing(1),
		backgroundColor: '#FEF200',
		color: '#1a1a1a',
		fontSize: 11,
		fontWeight: 700,
		padding: '2px 8px',
		borderRadius: 10,
	},
	infoFieldWrapper: {
		borderRadius: 10,
		padding: theme.spacing(1.5, 2),
		background: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.04)' : 'rgba(0,0,0,0.025)',
		border: `1px solid ${theme.palette.type === 'dark' ? 'rgba(255,255,255,0.07)' : 'rgba(0,0,0,0.07)'}`,
		marginTop: theme.spacing(1),
	},
	infoLabel: {
		fontSize: 11,
		fontWeight: 600,
		letterSpacing: '0.08em',
		textTransform: 'uppercase',
		color: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.45)' : 'rgba(0,0,0,0.42)',
		marginBottom: 4,
	},
	infoValue: {
		fontSize: 14,
		fontWeight: 500,
		whiteSpace: 'pre-line',
		lineHeight: 1.5,
		color: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.87)' : 'rgba(0,0,0,0.8)',
	},
	checkinImageCard: {
		borderRadius: 12,
		overflow: 'hidden',
		position: 'relative',
		background: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.04)',
		border: `1px solid ${theme.palette.type === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.08)'}`,
		marginTop: theme.spacing(1),
		'&:hover $checkinImageOverlay': {
			opacity: 1,
		},
	},
	checkinImageOverlay: {
		position: 'absolute',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		background: 'rgba(0,0,0,0.35)',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		opacity: 0,
		transition: 'opacity 0.2s ease',
		pointerEvents: 'none',
	},
	galleryItemWrapper: {
		position: 'relative',
		borderRadius: 12,
		overflow: 'hidden',
		background: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.05)' : '#f5f5f5',
		transition: 'transform 0.2s ease, box-shadow 0.2s ease',
		cursor: 'pointer',
		'&:hover': {
			transform: 'scale(1.025)',
			boxShadow: theme.palette.type === 'dark'
				? '0 8px 24px rgba(0,0,0,0.5)'
				: '0 8px 24px rgba(0,0,0,0.18)',
		},
		'&:hover $galleryItemOverlay': {
			opacity: 1,
		},
	},
	galleryItemOverlay: {
		position: 'absolute',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		background: 'linear-gradient(to top, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0) 50%)',
		opacity: 0,
		transition: 'opacity 0.2s ease',
		pointerEvents: 'none',
		display: 'flex',
		alignItems: 'flex-end',
		paddingBottom: theme.spacing(1),
		paddingLeft: theme.spacing(1),
		paddingRight: theme.spacing(1),
	},
	galleryItemMeta: {
		fontSize: 11,
		fontWeight: 600,
		color: 'rgba(255,255,255,0.92)',
		letterSpacing: '0.02em',
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		width: '100%',
	},
	mapLegendBar: {
		display: 'flex',
		alignItems: 'center',
		gap: theme.spacing(2.5),
		marginLeft: 'auto',
	},
	mapLegendDot: {
		width: 10,
		height: 10,
		borderRadius: '50%',
		display: 'inline-block',
		marginRight: 5,
		flexShrink: 0,
	},
	mapLegendItem: {
		display: 'flex',
		alignItems: 'center',
		fontSize: 12,
		fontWeight: 500,
		color: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.6)' : 'rgba(0,0,0,0.55)',
	},
	mapLoadingBox: {
		width: '100%',
		height: 600,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flexDirection: 'column',
		gap: theme.spacing(1.5),
		background: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.03)',
		borderRadius: 12,
	},
	// â”€â”€ åŽŸæœ‰ scrollableContent â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
	scrollableContent: {
		'&::-webkit-scrollbar': {
			width: '6px',
			height: '6px',
		},
		'&::-webkit-scrollbar-track': {
			background: 'transparent',
		},
		'&::-webkit-scrollbar-thumb': {
			background: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.1)',
			borderRadius: '3px',
			transition: 'background 0.3s ease',
		},
		'&:hover::-webkit-scrollbar-thumb': {
			background: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.2)',
		},
		'&::-webkit-scrollbar-thumb:hover': {
			background: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.4)' : 'rgba(0, 0, 0, 0.4)',
		},
		scrollbarWidth: 'thin',
		scrollbarColor: (theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.2)') + ' transparent',
	},
	// ── Upload button ──
	uploadBtn: {
		marginLeft: 'auto',
		width: 30,
		height: 30,
		borderRadius: 8,
		backgroundColor: 'rgba(254,242,0,0.08)',
		border: '1px solid rgba(254,242,0,0.15)',
		color: '#FEF200',
		'&:hover': { backgroundColor: 'rgba(254,242,0,0.15)' },
	},
	// ── Upload dialog ──
	uploadDialogHeader: {
		display: 'flex',
		alignItems: 'center',
		padding: '12px 20px',
		borderBottom: `1px solid ${theme.palette.type === 'dark' ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.08)'}`,
	},
	uploadDialogContent: {
		display: 'flex',
		gap: 20,
		padding: 20,
		minHeight: 340,
	},
	uploadDropZone: {
		border: `2px dashed ${theme.palette.type === 'dark' ? 'rgba(255,255,255,0.15)' : 'rgba(0,0,0,0.15)'}`,
		borderRadius: 12,
		padding: '32px 20px',
		textAlign: 'center',
		backgroundColor: 'rgba(254,242,0,0.02)',
		cursor: 'pointer',
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		transition: 'border-color 0.2s, background-color 0.2s',
	},
	uploadDropZoneHover: {
		borderColor: 'rgba(254,242,0,0.5)',
		backgroundColor: 'rgba(254,242,0,0.06)',
	},
	uploadDropZoneIcon: {
		width: 48,
		height: 48,
		borderRadius: 12,
		backgroundColor: 'rgba(254,242,0,0.1)',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		marginBottom: 12,
	},
	uploadPreviewGrid: {
		display: 'grid',
		gridTemplateColumns: 'repeat(4, 1fr)',
		gap: 8,
		marginTop: 12,
	},
	uploadPreviewItem: {
		aspectRatio: '1',
		borderRadius: 8,
		position: 'relative',
		overflow: 'hidden',
		backgroundColor: theme.palette.type === 'dark' ? '#333' : '#e0e0e0',
	},
	uploadPreviewImg: {
		width: '100%',
		height: '100%',
		objectFit: 'cover',
		display: 'block',
	},
	uploadDeleteBadge: {
		position: 'absolute',
		top: 4,
		right: 4,
		width: 18,
		height: 18,
		backgroundColor: 'rgba(255,68,68,0.9)',
		borderRadius: '50%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		color: 'white',
		fontSize: 10,
		cursor: 'pointer',
		'&:hover': { backgroundColor: '#ff4444' },
	},
	uploadAddMore: {
		aspectRatio: '1',
		border: `2px dashed ${theme.palette.type === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'}`,
		borderRadius: 8,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		cursor: 'pointer',
		color: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
		fontSize: 20,
		'&:hover': {
			borderColor: 'rgba(254,242,0,0.3)',
			color: '#FEF200',
		},
	},
	uploadDivider: {
		width: 1,
		backgroundColor: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.08)',
	},
	uploadRightPanel: {
		width: 220,
		display: 'flex',
		flexDirection: 'column',
		gap: 16,
	},
	uploadCategoryLabel: {
		fontSize: 11,
		fontWeight: 600,
		color: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.45)' : 'rgba(0,0,0,0.42)',
		textTransform: 'uppercase',
		letterSpacing: '0.08em',
		marginBottom: 8,
	},
	uploadCategorySelector: {
		border: `1px solid ${theme.palette.type === 'dark' ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.12)'}`,
		borderRadius: 8,
		padding: '10px 12px',
		cursor: 'pointer',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		transition: 'border-color 0.2s',
		'&:hover': {
			borderColor: 'rgba(254,242,0,0.4)',
		},
	},
	uploadChipContainer: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: 6,
	},
	uploadChip: {
		backgroundColor: '#FEF200',
		color: '#1a1a1a',
		fontWeight: 600,
		fontSize: 11,
	},
	uploadSaveBtn: {
		backgroundColor: '#FEF200',
		color: '#1a1a1a',
		fontWeight: 600,
		borderRadius: 8,
		padding: '8px 20px',
		boxShadow: '0 2px 8px rgba(254,242,0,0.25)',
		'&:hover': { backgroundColor: '#e6da00' },
		'&:disabled': { backgroundColor: 'rgba(254,242,0,0.3)', color: 'rgba(26,26,26,0.5)' },
	},
	uploadCancelBtn: {
		borderRadius: 8,
		padding: '8px 16px',
		color: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.6)' : 'rgba(0,0,0,0.5)',
		border: `1px solid ${theme.palette.type === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'}`,
	},
	uploadFileBadge: {
		backgroundColor: 'rgba(254,242,0,0.12)',
		color: '#FEF200',
		padding: '2px 10px',
		borderRadius: 12,
		fontSize: 11,
		fontWeight: 600,
		border: '1px solid rgba(254,242,0,0.2)',
		marginLeft: 12,
	},
	// ── Category-grouped gallery ──
	categoryGroupHeader: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		cursor: 'pointer',
		marginBottom: 8,
		'&:hover': { opacity: 0.8 },
	},
	categoryTag: {
		backgroundColor: 'rgba(254,242,0,0.12)',
		color: '#FEF200',
		padding: '2px 10px',
		borderRadius: 6,
		fontSize: 10,
		fontWeight: 600,
		letterSpacing: '0.02em',
		border: '1px solid rgba(254,242,0,0.2)',
	},
	categoryTagOther: {
		backgroundColor: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.06)',
		color: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.5)',
		padding: '2px 10px',
		borderRadius: 6,
		fontSize: 10,
		fontWeight: 600,
		letterSpacing: '0.02em',
		border: `1px solid ${theme.palette.type === 'dark' ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.08)'}`,
	},
	categoryGroupCount: {
		color: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.35)' : 'rgba(0,0,0,0.35)',
		fontSize: 10,
	},
	categoryGroupGrid: {
		paddingLeft: 18,
		marginBottom: 16,
	},
	categoryGroupImage: {
		aspectRatio: '10/8',
		borderRadius: 10,
		overflow: 'hidden',
		cursor: 'pointer',
		position: 'relative',
		border: `1px solid ${theme.palette.type === 'dark' ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.06)'}`,
		transition: 'transform 0.2s ease, box-shadow 0.2s ease',
		'&:hover': {
			transform: 'scale(1.025)',
			boxShadow: theme.palette.type === 'dark'
				? '0 8px 24px rgba(0,0,0,0.5)'
				: '0 8px 24px rgba(0,0,0,0.18)',
		},
		'&:hover $categoryGroupImageOverlay': {
			opacity: 1,
		},
	},
	categoryGroupImageOverlay: {
		position: 'absolute',
		bottom: 0,
		left: 0,
		right: 0,
		padding: '6px 8px',
		background: 'linear-gradient(transparent, rgba(0,0,0,0.75))',
		opacity: 0,
		transition: 'opacity 0.2s ease',
	},
}));

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

const labels = {
	mobile_checkin_id: "Doc ID",
	st_id: "Stock Take ID",
	staff_code: "Agent",
	person_met: "Person Met",
	cust_company_name: "Outlet",
	create_date: "Date",
	checkin_time: "Checked-In",
	// checkin_location: "Checked-In At",
	checkout_time: "Checked-Out",
	// checkout_location: "Checked-Out At",
	total_break_time: "Total Break Time",
	remark1: "Remark",
	remark2: "Contact Number",
	// remark3: "Remark 3"
	info_questionnaire: "Got Carry Khee San Products ?",
	checkin_image: "Check-in Image",
	checkout_image: "Check-out Image",
};
const schedLabels = {
	sched_datetime: "Appointment Date",
	sched_note: "Note",
	site_in_charge: "Site In-Charge",
	site_in_charge_contact: 'Contact'
}

const headCells = [
	{
		name: "st_id",
		label: "Stock Take ID",
		options: {
			display: true
		}
	},
	{
		name: "cust_code",
		label: "Outlet Code",
		options: {
			display: true
		}
	},
	{
		name: "cust_company_name",
		label: "Outlet Name",
		options: {
			display: true,
		}
	},
	{
		name: "name",
		label: "Agent",
		options: {
			display: true
		}
	},
	{
		name: "created_date",
		label: "Created Date",
		options: {
			display: true,
			customBodyRender: (value, tableMeta, updateValue) => {
				return (
					moment(value, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY')
				)
			}
		}
	},
	{
		name: "doc_ref_id",
		label: "Doc Ref",
		options: {
			display: true,
			customBodyRender: (value, tableMeta, updateValue) => {
				return (
					_.truncate(value)
				)
			}
		}
	},
	{
		name: "active_status",
		label: "Active Status",
		options: {
			display: true,
			customBodyRender: (value, tableMeta, updateValue) => {
				switch (value) {
					case "1":
						return (<Chip size="small" icon={<DoneIcon />} label="Active" />);
						break;
					case "0":
						return (<Chip size="small" icon={<CloseIcon />} label="Inactive" />);
						break;
					default:
						return (<Chip size="small" icon={<DoneIcon />} label="Active" />);
						break;
				}
			}
		}
	},
	{
		name: "st_fault_message",
		label: "Doc Fault Message",
		options: {
			display: false
		}
	}
]

const transferheadCells = [
	{
		name: "st_code",
		label: "Stock Take ID",
		options: {
			display: true
		}
	},
	{
		name: "st_date",
		label: "Doc Date",
		options: {
			display: true,
			customBodyRender: (value, tableMeta, updateValue) => {
				return (
					moment(value, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY')
				)
			}
		}
	},
	{
		name: "from_location",
		label: "From Location",
		options: {
			display: true
		}
	},
	{
		name: "to_location",
		label: "To Location",
		options: {
			display: true
		}
	},
	{
		name: "cust_code",
		label: "Outlet Code",
		options: {
			display: false
		}
	},
	{
		name: "cust_company_name",
		label: "Outlet Name",
		options: {
			display: false
		}
	},
	{
		name: "name",
		label: "Agent",
		options: {
			display: true
		}
	},
	{
		name: "note",
		label: "Note",
		options: {
			display: true,
			customBodyRender: (value, tableMeta, updateValue) => {
				return (
					_.truncate(value)
				)
			}
		}
	},
	{
		name: "total",
		label: "Grand Total",
		options: {
			display: true,
			customBodyRender: (value, tableMeta, updateValue) => {
				return (
					JString(value).inCurrency()
				)
			}
		}
	},
	{
		name: "cancel_status",
		label: "Cancel Status",
		options: {
			display: false,
			customBodyRender: (value, tableMeta, updateValue) => {
				switch (value) {
					case "0":
						return (<Chip size="small" icon={<DoneIcon />} label="Active" />);
						break;
					case "1":
						return (<Chip size="small" icon={<CloseIcon />} label="Cancelled" />);
						break;
					default:
						return (<Chip size="small" icon={<DoneIcon />} label="Active" />);
						break;
				}
			}
		}
	},
	{
		name: "st_fault_message",
		label: "Doc Fault Message",
		options: {
			display: false
		}
	}
]

const MarkerInfoCard = ({ info }) => {
	const theme = useTheme();

	const renderSingleInfo = (item, isLast) => (
		<Box mb={isLast ? 0 : 2}>
			<Typography variant="subtitle1" style={{ fontWeight: 600, color: '#FFFF00', display: 'flex', alignItems: 'center', marginBottom: 8 }}>
				{item.type === 'outlet' ? <RoomIcon style={{ marginRight: 4, color: '#f44336' }} /> :
					item.type === 'checkin' ? <RoomIcon style={{ marginRight: 4, color: '#4caf50' }} /> :
						<RoomIcon style={{ marginRight: 4, color: '#2196f3' }} />
				}
				{item.title}
			</Typography>

			{item.time && (
				<Box display="flex" alignItems="center" mb={0.5} style={{ color: 'white' }}>
					<AccessTimeIcon style={{ marginRight: 8, fontSize: 16 }} />
					<Typography variant="body2" style={{ fontSize: 13 }}>{item.time}</Typography>
				</Box>
			)}

			<Box display="flex" alignItems="flex-start" style={{ color: 'white' }}>
				<PublicIcon style={{ marginRight: 8, fontSize: 16, marginTop: 2 }} />
				<Typography variant="body2" style={{ fontSize: 13 }}>
					{item.lat.toFixed(6)}, {item.lng.toFixed(6)}
				</Typography>
			</Box>
		</Box>
	);

	return (
		<Card elevation={4} style={{ borderRadius: 8, minWidth: 220, maxWidth: 320, backgroundColor: '#424242' }}>
			<CardContent style={{ padding: 16, paddingBottom: 16 }}>
				{info.type === 'merged' ? (
					info.items.map((item, index) => (
						<React.Fragment key={index}>
							{renderSingleInfo(item, index === info.items.length - 1)}
							{index < info.items.length - 1 && <Divider style={{ margin: '12px 0', backgroundColor: 'rgba(255, 255, 255, 0.12)' }} />}
						</React.Fragment>
					))
				) : (
					renderSingleInfo(info, true)
				)}
			</CardContent>
		</Card>
	);
};

const CheckinMap = ({ checkinData }) => {
	const { isLoaded } = useJsApiLoader({
		id: 'google-map-script',
		googleMapsApiKey: "AIzaSyD3Glah-NDcJ0z7D4HtnO6QRMo23SSAyW8"
	});

	const [map, setMap] = useState(null);
	const [closedIndices, setClosedIndices] = useState([]);

	useEffect(() => {
		setClosedIndices([]);
	}, [checkinData]);

	const markers = useMemo(() => {
		if (!isLoaded) return [];
		const list = [];

		let checkinMarker = null;
		let checkoutMarker = null;

		// Outlet - Red Marker
		if (checkinData.latitude && checkinData.longitude && parseFloat(checkinData.latitude) !== 0 && parseFloat(checkinData.longitude) !== 0) {
			list.push({
				position: { lat: parseFloat(checkinData.latitude), lng: parseFloat(checkinData.longitude) },
				info: {
					type: 'outlet',
					title: "Outlet Location",
					lat: parseFloat(checkinData.latitude),
					lng: parseFloat(checkinData.longitude)
				},
				icon: {
					url: "http://maps.google.com/mapfiles/ms/icons/red-dot.png",
					scaledSize: new window.google.maps.Size(40, 40)
				},
				zIndex: 1
			});
		}

		// Checkin - Green Marker
		if (checkinData.location_lat && checkinData.location_lng && parseFloat(checkinData.location_lat) !== 0 && parseFloat(checkinData.location_lng) !== 0) {
			const time = checkinData.checkin_time ? moment(checkinData.checkin_time).format('DD/MM/YYYY hh:mm A') : 'N/A';
			checkinMarker = {
				position: { lat: parseFloat(checkinData.location_lat), lng: parseFloat(checkinData.location_lng) },
				info: {
					type: 'checkin',
					title: "Checkin Location",
					time: time,
					lat: parseFloat(checkinData.location_lat),
					lng: parseFloat(checkinData.location_lng)
				},
				icon: {
					url: "http://maps.google.com/mapfiles/ms/icons/green-dot.png",
					scaledSize: new window.google.maps.Size(40, 40)
				},
				zIndex: 2
			};
		}

		// Checkout - Blue Marker
		if (checkinData.checkout_lat && checkinData.checkout_lng && parseFloat(checkinData.checkout_lat) !== 0 && parseFloat(checkinData.checkout_lng) !== 0) {
			const time = checkinData.checkout_time ? moment(checkinData.checkout_time).format('DD/MM/YYYY hh:mm A') : 'N/A';
			checkoutMarker = {
				position: { lat: parseFloat(checkinData.checkout_lat), lng: parseFloat(checkinData.checkout_lng) },
				info: {
					type: 'checkout',
					title: "Checkout Location",
					time: time,
					lat: parseFloat(checkinData.checkout_lat),
					lng: parseFloat(checkinData.checkout_lng)
				},
				icon: {
					url: "http://maps.google.com/mapfiles/ms/icons/blue-dot.png",
					scaledSize: new window.google.maps.Size(40, 40)
				},
				zIndex: 1
			};
		}

		if (checkinMarker && checkoutMarker) {
			const from = point([checkinMarker.position.lng, checkinMarker.position.lat]);
			const to = point([checkoutMarker.position.lng, checkoutMarker.position.lat]);
			const dist = distance(from, to, { units: 'kilometers' });

			if (dist * 1000 < 5) {
				checkinMarker.info = {
					type: 'merged',
					items: [checkinMarker.info, checkoutMarker.info]
				};
				checkinMarker.zIndex = 3; // Bring to front
				checkoutMarker.hideInfoWindow = true;
			}
		}

		if (checkinMarker) list.push(checkinMarker);
		if (checkoutMarker) list.push(checkoutMarker);

		return list;
	}, [
		isLoaded,
		checkinData?.latitude,
		checkinData?.longitude,
		checkinData?.location_lat,
		checkinData?.location_lng,
		checkinData?.checkout_lat,
		checkinData?.checkout_lng,
		checkinData?.checkin_time,
		checkinData?.checkout_time
	]);

	const defaultCenter = useMemo(() => {
		if (markers.length > 0) return markers[0].position;
		return { lat: 3.142540, lng: 101.621420 };
	}, [markers]);

	const onLoad = React.useCallback(function callback(map) {
		const bounds = new window.google.maps.LatLngBounds();
		if (markers.length > 0) {
			markers.forEach(marker => {
				bounds.extend(marker.position);
			});
			map.fitBounds(bounds);
		} else {
			map.setCenter(defaultCenter);
			map.setZoom(15);
		}
		setMap(map);
	}, [markers, defaultCenter]);

	const onUnmount = React.useCallback(function callback(map) {
		setMap(null);
	}, []);

	const classes = useStyles();

	if (!isLoaded) {
		return (
			<div>
				{/* Section æ ‡é¢˜ */}
				<div className={classes.sectionHeader}>
					<div className={classes.sectionAccent} />
					<span className={classes.sectionTitle}>Location Map</span>
				</div>
				<div className={classes.mapLoadingBox}>
					<div style={{
						width: 48,
						height: 48,
						borderRadius: '50%',
						border: '4px solid rgba(0,0,0,0.08)',
						borderTopColor: '#FEF200',
						animation: 'spin 1s linear infinite'
					}} />
					<Typography style={{ fontSize: 13, color: 'rgba(0,0,0,0.4)', fontWeight: 500 }}>
						Loading map...
					</Typography>
				</div>
			</div>
		);
	}

	return (
		<div>
			{/* Section æ ‡é¢˜ + å›¾ä¾‹ */}
			<div className={classes.sectionHeader}>
				<div className={classes.sectionAccent} />
				<span className={classes.sectionTitle}>Location Map</span>
				<div className={classes.mapLegendBar}>
					<span className={classes.mapLegendItem}>
						<span className={classes.mapLegendDot} style={{ backgroundColor: '#f44336' }} />
						Outlet
					</span>
					<span className={classes.mapLegendItem}>
						<span className={classes.mapLegendDot} style={{ backgroundColor: '#4caf50' }} />
						Check-in
					</span>
					<span className={classes.mapLegendItem}>
						<span className={classes.mapLegendDot} style={{ backgroundColor: '#2196f3' }} />
						Check-out
					</span>
				</div>
			</div>
			{/* åœ°å›¾å®¹å™¨ */}
			<div style={{ borderRadius: 12, overflow: 'hidden' }}>
				<GoogleMap
					mapContainerStyle={{ width: '100%', height: '600px' }}
					onLoad={onLoad}
					onUnmount={onUnmount}
					options={{
						styles: [], // light theme
					}}
				>
					{markers.map((marker, index) => (
						<Marker
							key={index}
							position={marker.position}
							icon={marker.icon}
							zIndex={marker.zIndex}
							onClick={() => setClosedIndices(prev => prev.filter(i => i !== index))}
						>
							{!closedIndices.includes(index) && !marker.hideInfoWindow && (
								<OverlayView
									position={marker.position}
									mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
								>
									<div style={{ position: 'absolute', transform: 'translate(-50%, -100%)', paddingBottom: '45px' }}>
										<IconButton
											size="small"
											onClick={() => setClosedIndices(prev => [...prev, index])}
											style={{
												position: 'absolute',
												top: -10,
												right: -10,
												backgroundColor: '#424242',
												color: 'white',
												boxShadow: '0px 2px 4px rgba(0,0,0,0.2)',
												zIndex: 1000,
												padding: 4
											}}
										>
											<CloseIcon fontSize="small" />
										</IconButton>
										<MarkerInfoCard
											info={marker.info}
										/>
									</div>
								</OverlayView>
							)}
						</Marker>
					))}
				</GoogleMap>
			</div>
		</div>
	);
}

const CheckinInfoSection = ({ checkinData, classes, setSelectedImage, checkinImageOverrides = {} }) => {
	if (!checkinData) return null;

	const imageKeys = ['checkin_image', 'checkout_image'];
	const timeFields = ['checkin_time', 'checkout_time', 'total_break_time'];
	const textKeys = Object.keys(labels).filter(k => !imageKeys.includes(k) && !timeFields.includes(k));

	const resolveValue = (key) => {
		var listValue = '-';
		Object.keys(checkinData).map((nKey) => {
			if (nKey === 'schedule') return null;
			if (nKey === key) {
				listValue = checkinData[nKey] || '-';
				if (nKey === 'st_id') {
					var st_id = '';
					for (let i = 0; i < listValue.length; i++) {
						st_id += listValue[i]['st_id'];
						if (i !== listValue.length - 1) st_id += ',';
					}
					listValue = st_id;
				}
				if (key === 'remark3') {
					var remark = '';
					for (let i = 0; i < checkinData['remark3'].length; i++) {
						if (checkinData['remark3'][i]['code'] === 'collection') {
							remark += checkinData['remark3'][i]['value'];
							if (checkinData['remark3'][i]['selected'] !== '') remark += '. Yes\n';
						}
					}
					listValue = remark === '' ? '-' : remark;
				}
				if (key === 'info_questionnaire' && checkinData[nKey] == null) {
					listValue = '404 Not Found';
				}
				if (key === 'info_questionnaire' && checkinData[nKey] != null) {
					const temp_array = checkinData[nKey];
					if (temp_array.length > 0 && temp_array != '') {
						temp_array.map(item => {
							if (item.selected_option === 'yes' || item.selected_option === 'no') {
								listValue = item.selected_option + ', ' + (item.selected_option === 'yes' ? item.yes_option : item.no_option);
							} else {
								listValue = '-';
							}
						});
					} else {
						listValue = '-';
					}
				}
			}
		});
		if (key === 'create_date' || key === 'checkin_time' || key === 'checkout_time') {
			if (!listValue || listValue === '0000-00-00 00:00:00') {
				listValue = '-';
			} else {
				listValue = moment(listValue, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY hh:mm A');
				if (key === 'checkin_time') listValue += '\n' + (checkinData['checkin_location'] || '');
				else if (key === 'checkout_time') listValue += '\n' + (checkinData['checkout_location'] || '');
			}
		}
		return listValue;
	};

	return (
		<Grid container spacing={3} alignItems="stretch">
			{/* Section Header */}
			<Grid item xs={12}>
				<div className={classes.sectionHeader}>
					<div className={classes.sectionAccent} />
					<span className={classes.sectionTitle}>Basic Information</span>
				</div>
			</Grid>

			{/* Left two columns: text fields */}
			<Grid item xs={8} style={{ display: 'flex' }}>
				<Grid container spacing={2} style={{ flex: 1, alignContent: 'stretch' }}>
					{textKeys.map((key, idx) => {
						const listValue = resolveValue(key);
						if (listValue === '404 Not Found') return null;
						return (
							<Grid key={idx} item xs={6} style={{ display: 'flex' }}>
								<div className={classes.infoFieldWrapper} style={{ flex: 1 }}>
									<div className={classes.infoLabel}>{labels[key]}</div>
									<div className={classes.infoValue}>{listValue}</div>
								</div>
							</Grid>
						);
					})}
					{/* Time fields - 3 columns */}
					{timeFields.map((key, idx) => {
						const listValue = resolveValue(key);
						return (
							<Grid key={`time-${idx}`} item xs={4} style={{ display: 'flex' }}>
								<div className={classes.infoFieldWrapper} style={{ flex: 1 }}>
									<div className={classes.infoLabel}>{labels[key]}</div>
									<div className={classes.infoValue}>{listValue}</div>
								</div>
							</Grid>
						);
					})}
				</Grid>
			</Grid>

			{/* Right column: Check-in Image & Check-out Image */}
			<Grid item xs={4}>
				{imageKeys.map((key, idx) => {
					const imgSrc = checkinImageOverrides[key] || checkinData[key];
					const idKey = key === 'checkin_image' ? 'checkin_image_id' : 'checkout_image_id';
					const imgId = checkinData[idKey];
					return (
						<div key={idx} style={{ marginTop: idx === 0 ? 0 : 16 }}>
							<div className={classes.infoLabel} style={{ marginBottom: 6 }}>{labels[key]}</div>
							{imgSrc ? (
								<div
									className={classes.checkinImageCard}
									onClick={() => setSelectedImage && setSelectedImage({ upload_image: imgSrc, upload_id: imgId })}
									style={{ cursor: setSelectedImage ? 'pointer' : 'default' }}
								>
									<img
										src={imgSrc}
										alt={labels[key]}
										style={{
											width: '100%',
											maxHeight: 200,
											objectFit: 'cover',
											display: 'block',
										}}
									/>
									{setSelectedImage && (
										<div className={classes.checkinImageOverlay}>
											<Typography style={{ color: '#fff', fontSize: 12, fontWeight: 600, letterSpacing: '0.05em' }}>
												View Full
											</Typography>
										</div>
									)}
								</div>
							) : (
								<div className={classes.infoFieldWrapper} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 80 }}>
									<Typography style={{ fontSize: 13, opacity: 0.4 }}>No image</Typography>
								</div>
							)}
						</div>
					);
				})}
			</Grid>
		</Grid>
	);
};

const ScheduleInfoSection = ({ checkinData, classes }) => {
	return (
		<>
			{
				Object.keys(checkinData?.schedule || {})?.length > 0 &&
				<>
					{/* Section Header */}
					<div className={classes.sectionHeader}>
						<div className={classes.sectionAccent} />
						<span className={classes.sectionTitle}>Schedule</span>
					</div>
					<Grid container spacing={2}>
						{Object.keys(checkinData?.schedule || {}).map
							((field, index) => {
								if (['sched_datetime', 'sched_note', 'site_in_charge', 'site_in_charge_contact'].includes(field)) {
									var listValue = checkinData.schedule[field];
									if (field == 'sched_datetime') {
										listValue = moment(listValue, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY hh:mm A');
									}
									return (
										<Grid item xs={6} key={String(index)}>
											<div className={classes.infoFieldWrapper}>
												<div className={classes.infoLabel}>{schedLabels[field]}</div>
												<div className={classes.infoValue}>{listValue || '-'}</div>
											</div>
										</Grid>
									)
								}
								if (['tags', 'project_no'].includes(field)) {
									var listValue = checkinData.schedule[field];
									if (!listValue) return null;
									if (field == 'tags') {
										return (
											<Grid item xs={12} key={String(index)}>
												<div>
													{
														Object.keys(listValue).map((item, inx) => {
															return (
																<div
																	style={{ marginTop: 10 }}
																	key={String(inx)}>
																	<div className={classes.infoLabel}>
																		{String(item).toUpperCase()}
																	</div>
																	<div className={classes.row}>
																		{
																			listValue[item] && listValue[item].map((tag, idx) =>
																				<Chip
																					key={String(idx)}
																					variant={'outlined'}
																					label={tag}
																				/>
																			)
																		}
																	</div>
																</div>
															)
														})
													}
												</div>
											</Grid>
										)
									}
									if (field == 'project_no') {
										return (
											<Grid item xs={12} key={String(index)}>
												<div>
													{
														listValue.map((item, index) =>
															<div
																style={{ marginTop: 10 }}
																key={String(index)}>
																<div className={classes.infoLabel}>
																	Project Code
																</div>
																<Chip
																	variant={'outlined'}
																	label={item.project_code}
																/>
															</div>
														)
													}
												</div>
											</Grid>
										)
									}
								}
							})
						}
					</Grid>
				</>
			}
		</>
	);
};

const ImagesSection = ({ attachments, classes, setSelectedImage, style, onUploadClick, language }) => {
	const [collapsedGroups, setCollapsedGroups] = React.useState({});

	var grouped = React.useMemo(function () {
		var groups = {};
		if (!attachments) return [];
		attachments.forEach(function (item) {
			var key = item.upload_type_name || 'Other';
			if (!groups[key]) groups[key] = [];
			groups[key].push(item);
		});
		return Object.entries(groups);
	}, [attachments]);

	var toggleGroup = function (name) {
		setCollapsedGroups(function (prev) {
			var next = Object.assign({}, prev);
			next[name] = !prev[name];
			return next;
		});
	};

	return (
		<div style={{ ...style, width: '100%' }}>
			<div className={classes.sectionHeader}>
				<div className={classes.sectionAccent} />
				<span className={classes.sectionTitle}>Photos</span>
				{attachments && attachments.length > 0 && (
					<span className={classes.sectionBadge}>{attachments.length}</span>
				)}
				{onUploadClick && (
					<IconButton className={classes.uploadBtn} onClick={onUploadClick} size="small">
						<AddPhotoAlternateIcon fontSize="small" />
					</IconButton>
				)}
			</div>
			{grouped.map(function (entry) {
				var groupName = entry[0];
				var items = entry[1];
				var isCollapsed = collapsedGroups[groupName];
				var isOther = groupName === 'Other';
				return (
					<div key={groupName}>
						<div className={classes.categoryGroupHeader} onClick={function () { toggleGroup(groupName); }}>
							{isCollapsed ? <ExpandMoreIcon style={{ fontSize: 14, color: 'rgba(255,255,255,0.4)' }} /> : <ExpandLessIcon style={{ fontSize: 14, color: 'rgba(255,255,255,0.4)' }} />}
							<span className={isOther ? classes.categoryTagOther : classes.categoryTag}>{groupName}</span>
							<span className={classes.categoryGroupCount}>{items.length}</span>
						</div>
						<Collapse in={!isCollapsed}>
							<div className={classes.categoryGroupGrid}>
								<Grid container spacing={1}>
									{items.map(function (item, index) {
										return (
											<Grid item xs={6} key={String(index)}>
												<div
													className={classes.categoryGroupImage}
													onClick={function () { setSelectedImage(item); }}
												>
													<img
														src={item.upload_image || no_image}
														alt={item.upload_type_name || 'Photo'}
														style={{
															width: '100%',
															aspectRatio: '10/8',
															objectFit: 'cover',
															display: 'block',
														}}
													/>
													<div className={classes.categoryGroupImageOverlay}>
														<span style={{ fontSize: 10, color: 'rgba(255,255,255,0.85)', fontWeight: 600, letterSpacing: '0.02em' }}>
															{item.upload_type_name || item.upload_remark || ''}
														</span>
													</div>
												</div>
											</Grid>
										);
									})}
								</Grid>
							</div>
						</Collapse>
					</div>
				);
			})}
		</div>
	);
};

export default function CheckinDetails({
	checkinData,
	open,
	setClose,
	language,
	axiosApiConfig,
	current_username,
	snack,
	customerList
}) {
	const classes = useStyles();
	const commonStyles = useCommonStyles();
	const paperStyle = usePaperStyles();
	const [userLocations, setUserLocations] = useState([]);
	const [currentPage, setCurrentPage] = useState(0);
	const [currentST, setCurrentST] = useState(0);
	const [showDocDetails, toggleDocDetails] = useState(false);
	const [appSTList, setAppSTList] = useState([]);
	const [conSTList, setConSTList] = useState([]);
	const [transSTList, setTransSTList] = useState([]);
	const [postSTList, setPostSTList] = useState([]);
	const [currentSTrans, setCurrentSTrans] = useState(0);
	const [showTransDocDetails, toggleTransDocDetails] = useState(false);
	const [appSTransList, setAppSTransList] = useState([]);
	const [conSTransList, setConSTransList] = useState([]);
	const [transSTransList, setTransSTransList] = useState([]);
	const [postSTransList, setPostSTransList] = useState([]);
	const [sTransInclude, setSTransInclude] = useState(0);
	const [approveCheckinID, setApproveCheckinID] = useState(null);
	const [approveSalespersonID, setApproveSalespersonID] = useState(null);
	const [approveOutletName, setApproveOutletName] = useState(null);
	const [approveOutletAddr, setApproveOutletAddr] = useState(null);
	const [cView, setCView] = useState(false);
	const [stToView, setSTToView] = useState(null);
	const [attachments, setAttachments] = useState([]);
	const [uploadDialogOpen, setUploadDialogOpen] = useState(false);
	const [uploadFiles, setUploadFiles] = useState([]);
	const [uploadPreviews, setUploadPreviews] = useState([]);
	const [categoryList, setCategoryList] = useState([]);
	const [selectedCategories, setSelectedCategories] = useState([]);
	const [categoryViewOpen, setCategoryViewOpen] = useState(false);
	const [isUploading, setIsUploading] = useState(false);
	const [isDragOver, setIsDragOver] = useState(false);
	const fileInputRef = React.useRef(null);

	useEffect(() => {
		if (open) {
			const { checkin_time, checkout_time, salesperson_id, mobile_checkin_id, latitude, longitude, location_lat, location_lng, checkout_lat, checkout_lng } = checkinData;
			const param = axiosURIencode({
				mobile_checkin_id: mobile_checkin_id,
				from_time: checkin_time,
				to_time: checkout_time,
				salesperson_id
			});

			API_Service.get(`${req_checkin_stocktake}?${param}`, axiosApiConfig).then(({ data }) => {
				const { result, extraData } = data;
				if (parseInt(result) === 1) {
					var apparr = extraData.filter((item) => item.st_status === '0');
					var conarr = extraData.filter((item) => item.st_status === '1');
					var transarr = extraData.filter((item) => item.st_status === '2');
					var postarr = extraData.filter((item) => item.st_status === '3');
					// de("betty-req_checkin_stocktake", extraData, apparr, conarr, transarr, postarr);
					setAppSTList(apparr);
					setConSTList(conarr);
					setTransSTList(transarr);
					setPostSTList(postarr);
				}
			});

			reloadImages();

			API_Service.get(`${req_checkin_stocktransfer}?${param}`, axiosApiConfig).then(({ data }) => {
				const { result, extraData } = data;
				if (parseInt(result) === 1) {
					var apptransarr = extraData.filter((item) => item.st_status === '0');
					var contransarr = extraData.filter((item) => item.st_status === '1');
					var trantranssarr = extraData.filter((item) => item.st_status === '2');
					var posttransarr = extraData.filter((item) => item.st_status === '3');
					// de("betty-req_checkin_stocktransfer", extraData, apptransarr, contransarr, trantranssarr, posttransarr);
					setAppSTransList(apptransarr);
					setConSTransList(contransarr);
					setTransSTransList(trantranssarr);
					setPostSTransList(posttransarr);
				}
			});

			// API_Service.get(`${req_salesman_location}?${param}`, axiosApiConfig).then(({ data }) => {
			// 	const { result, extraData } = data;
			// 	if (parseInt(result) === 1) {
			// 		setUserLocations(extraData);
			// 	}
			// });

			API_Service.get(req_module_setting, axiosApiConfig).then(({ data }) => {
				const { result, extraData } = data;
				if (result == 1) {
					setSTransInclude(getSetting(extraData, 'StockTransfer')?.include);
				} else {
					setSTransInclude([]);
				}
			});
		}
	}, [open]);

	const reloadImages = () => {
		const param = axiosURIencode({
			mobile_checkin_id: checkinData.mobile_checkin_id,
			from_time: checkinData.checkin_time,
			to_time: checkinData.checkout_time,
			salesperson_id: checkinData.salesperson_id
		});
		API_Service.get(`${req_checkin_images}?${param}`, axiosApiConfig).then(({ data }) => {
			const { result, extraData } = data;
			if (parseInt(result) === 1) {
				setAttachments(extraData);
			}
		});
	};

	useEffect(() => {
		if (uploadDialogOpen) {
			API_Service.get(req_gallery_type2, axiosApiConfig).then(({ data }) => {
				if (data.result == 1) {
					setCategoryList(data.extraData);
				}
			});
		}
	}, [uploadDialogOpen]);

	const onCategorySelected = (value) => {
		setCategoryViewOpen(false);
		if (value && value.name === 'reset') {
			setSelectedCategories([]);
			return;
		}
		if (value && Array.isArray(value) && value.length > 0) {
			setSelectedCategories(value);
		}
	};

	var addFiles = function (newFiles) {
		var accepted = Array.from(newFiles).filter(function (f) {
			return f.type && f.type.match(/^image\/(jpeg|png|jpg|webp)$/);
		});
		if (accepted.length === 0) return;
		setUploadFiles(function (prev) {
			var combined = prev.concat(accepted).slice(0, 10);
			return combined;
		});
	};

	React.useEffect(function () {
		var urls = uploadFiles.map(function (f) { return URL.createObjectURL(f); });
		setUploadPreviews(urls);
		return function () { urls.forEach(function (u) { URL.revokeObjectURL(u); }); };
	}, [uploadFiles]);

	var removeFile = function (index) {
		setUploadFiles(function (prev) { return prev.filter(function (_, i) { return i !== index; }); });
	};

	var handleDrop = function (e) {
		e.preventDefault();
		setIsDragOver(false);
		if (e.dataTransfer.files) addFiles(e.dataTransfer.files);
	};

	var handleDragOver = function (e) { e.preventDefault(); setIsDragOver(true); };
	var handleDragLeave = function () { setIsDragOver(false); };

	const handleUploadSave = () => {
		if (uploadFiles.length === 0) {
			snack(language.no_image_selected, 'warning');
			return;
		}
		if (selectedCategories.length === 0) {
			snack(language.no_category_selected, 'warning');
			return;
		}
		setIsUploading(true);

		var promises = uploadFiles.map(function (file) {
			return new Promise(function (resolve) {
				var reader = new FileReader();
				reader.onload = function () {
					resolve('data:image/png;base64,' + arrayBufferToBase64(reader.result));
				};
				reader.readAsArrayBuffer(file);
			});
		});

		Promise.all(promises).then(function (base64Images) {
			var formdata = new FormData();
			formdata.append('images', JSON.stringify(base64Images));
			formdata.append('categories', JSON.stringify(
				selectedCategories.map(function (c) { return { type_id: c.value, type_name: c.name }; })
			));
			formdata.append('mobile_checkin_id', checkinData.mobile_checkin_id);
			formdata.append('salesperson_id', checkinData.salesperson_id);

			API_Service.post(req_checkin_uploadimage, formdata, axiosApiConfig)
				.then(function ({ data }) {
					if (data.result == 1) {
						snack(language.upload_success, 'success');
						setUploadDialogOpen(false);
						setUploadFiles([]);
						setSelectedCategories([]);
						reloadImages();
					} else {
						snack(data.message || language.upload_fail, 'error');
					}
				})
				.catch(function () {
					snack(language.upload_fail, 'error');
				})
				.finally(function () {
					setIsUploading(false);
				});
		});
	};

	const closeDialog = () => {
		setAppSTList([]);
		setConSTList([]);
		setTransSTList([]);
		setPostSTList([]);
		setAttachments([]);
		setAppSTransList([]);
		setConSTransList([]);
		setTransSTransList([]);
		setPostSTransList([]);
		setUserLocations([]);
		setSTransInclude([]);
		setSTToView(null);
		onClose();
	}

	const getSelectedDocIds = (data, type) => {
		var original_data = [];
		if (currentPage === 2) {
			original_data = conSTransList;
			if (type == 'transferred') {
				original_data = transSTransList;
			}
			if (type == 'posted') {
				original_data = postSTransList;
			}
			if (type == 'active') {
				original_data = appSTransList;
			}
		} else {
			original_data = conSTList;
			if (type == 'transferred') {
				original_data = transSTList;
			}
			if (type == 'posted') {
				original_data = postSTList;
			}
			if (type == 'active') {
				original_data = appSTList;
			}
		}

		var ids = "";
		for (let index = 0, size = data.length; index < size; index++) {
			const { dataIndex } = data[index];
			if (currentPage === 2) {
				const { st_code } = original_data[dataIndex];
				ids += JString(st_code).toString();
			} else {
				const { st_id } = original_data[dataIndex];
				ids += JString(st_id).toString();
			}
			if (index != (size - 1) && size != 1) {
				ids += ',';
			}
		}
		return ids;
	}

	const toggleDocStatus = (d, type = 'confirmed', status) => {
		var params = {
			doc_id: getSelectedDocIds(d, type),
			st_status: status,
			update_by: current_username
		};
		params = axiosURIencode(params);
		API_Service.put(req_stock_take_status, params, axiosApiConfig).then(({ data }) => {
			const { result } = data;
			if (result == 1) {
				var original_data = conSTList;
				if (type == 'transferred') {
					original_data = transSTList;
				}
				if (type == 'posted') {
					original_data = postSTList;
				}
				if (type == 'active') {
					original_data = appSTList;
				}
				for (let index = 0, size = d.length; index < size; index++) {
					const { dataIndex } = d[index];
					original_data[dataIndex]['st_status'] = status;
					if (status === 2) {
						transSTList.push(original_data[dataIndex]);
						original_data.splice(dataIndex, 1);
						setConSTList(original_data);
					} else if (status === 3) {
						postSTList.push(original_data[dataIndex]);
						original_data.splice(dataIndex, 1);
						setTransSTList(original_data);
					} else {
						conSTList.push(original_data[dataIndex]);
						original_data.splice(dataIndex, 1);
						setAppSTList(original_data);
					}
					setCurrentST(status);
				}
				snack(language.update_success);
			} else {
				snack(language.update_fail, 'warning');
			}
		})
	}

	const toggleTransferDocStatus = (d, type = 'confirmed', status) => {
		var params = {
			doc_id: getSelectedDocIds(d, type),
			st_status: status,
			update_by: current_username
		};
		params = axiosURIencode(params);
		API_Service.put(req_stock_transfer_status, params, axiosApiConfig).then(({ data }) => {
			const { result } = data;
			if (result == 1) {
				var original_data = conSTransList;
				if (type == 'transferred') {
					original_data = transSTransList;
				}
				if (type == 'posted') {
					original_data = postSTransList;
				}
				if (type == 'active') {
					original_data = appSTransList;
				}
				for (let index = 0, size = d.length; index < size; index++) {
					const { dataIndex } = d[index];
					original_data[dataIndex]['st_status'] = status;
					if (status === 2) {
						transSTransList.push(original_data[dataIndex]);
						original_data.splice(dataIndex, 1);
						setConSTransList(original_data);
					} else if (status === 3) {
						postSTransList.push(original_data[dataIndex]);
						original_data.splice(dataIndex, 1);
						setTransSTransList(original_data);
					} else {
						conSTransList.push(original_data[dataIndex]);
						original_data.splice(dataIndex, 1);
						setAppSTransList(original_data);
					}
					setCurrentSTrans(status);
				}
				snack(language.update_success);
			} else {
				snack(language.update_fail, 'warning');
			}
		})
	}

	const toggleDocCancel = (d, type = 'confirmed') => {
		var params = {
			doc_id: getSelectedDocIds(d, type),
			update_by: current_username,
			delete: 1
		};
		params = axiosURIencode(params);
		API_Service.put(req_stock_transfer_status, params, axiosApiConfig).then(({ data }) => {
			const { result } = data;
			if (result == 1) {
				snack(language.update_success);
			} else {
				snack(language.update_fail, 'warning');
			}
		})
	}

	const toggleTranserDocCancel = (d, type = 'confirmed') => {
		var params = {
			doc_id: getSelectedDocIds(d, type),
			update_by: current_username,
			delete: 1
		};
		params = axiosURIencode(params);
		API_Service.put(req_stock_take_status, params, axiosApiConfig).then(({ data }) => {
			const { result } = data;
			if (result == 1) {
				snack(language.update_success);
			} else {
				snack(language.update_fail, 'warning');
			}
		})
	}

	const theme = useTheme();
	const lightTheme = theme.palette.type === 'light';

	const onClose = () => {
		setClose();
	}

	const [selectedImage, setSelectedImage] = useState(null);
	const [imageZoom, setImageZoom] = useState(1);
	const [imagePosition, setImagePosition] = useState({ x: 0, y: 0 });
	const [imageRotation, setImageRotation] = useState(0);
	const [isSavingRotation, setIsSavingRotation] = useState(false);
	const [checkinImageOverrides, setCheckinImageOverrides] = useState({});
	const [imageGroup, setImageGroup] = useState(null);
	const [imageIndex, setImageIndex] = useState(0);

	// é¼ æ ‡æ‹–æ‹½çŠ¶æ€
	const [isDragging, setIsDragging] = useState(false);
	const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
	const [dragStartPosition, setDragStartPosition] = useState({ x: 0, y: 0 });

	// é¼ æ ‡äº‹ä»¶å¤„ç†å‡½æ•°
	const handleMouseDown = (e) => {
		if (imageZoom > 1) {
			setIsDragging(true);
			setDragStart({ x: e.clientX, y: e.clientY });
			setDragStartPosition({ x: imagePosition.x, y: imagePosition.y });
			e.preventDefault();
		}
	};

	const handleMouseMove = (e) => {
		if (isDragging && imageZoom > 1) {
			const deltaX = e.clientX - dragStart.x;
			const deltaY = e.clientY - dragStart.y;
			setImagePosition({
				x: dragStartPosition.x + deltaX,
				y: dragStartPosition.y + deltaY
			});
		}
	};

	const handleMouseUp = () => {
		setIsDragging(false);
	};

	useEffect(() => {
		if (isDragging) {
			document.addEventListener('mousemove', handleMouseMove);
			document.addEventListener('mouseup', handleMouseUp);
			return () => {
				document.removeEventListener('mousemove', handleMouseMove);
				document.removeEventListener('mouseup', handleMouseUp);
			};
		}
	}, [isDragging, dragStart, dragStartPosition]);

	const handleSaveRotation = () => {
		if (!selectedImage || imageRotation === 0 || isSavingRotation) return;
		setIsSavingRotation(true);

		const normalizedRotation = ((imageRotation % 360) + 360) % 360;
		const formData = new FormData();
		formData.append('upload_id', selectedImage.upload_id);
		formData.append('angle', normalizedRotation);

		API_Service.post(req_gallery_rotateimage, formData, axiosApiConfig).then(({ data }) => {
			const { result, extraData } = data;
			if (parseInt(result) === 1) {
				const baseUrl = extraData.upload_image;
				const newUrl = `${baseUrl}?t=${Date.now()}`;
				setSelectedImage(prev => ({ ...prev, upload_image: newUrl }));
				setAttachments(prev => prev.map(item =>
					item.upload_id === selectedImage.upload_id
						? { ...item, upload_image: newUrl }
						: item
				));
				// å®žæ—¶æ›´æ–° CheckinInfoSection ä¸­çš„ checkin/checkout å›¾ç‰‡
				if (selectedImage.upload_id === checkinData.checkin_image_id) {
					setCheckinImageOverrides(prev => ({ ...prev, checkin_image: newUrl }));
				} else if (selectedImage.upload_id === checkinData.checkout_image_id) {
					setCheckinImageOverrides(prev => ({ ...prev, checkout_image: newUrl }));
				}
				setImageRotation(0);
				snack('Image saved successfully', 'success');
			} else {
				snack('Failed to save image', 'error');
			}
			setIsSavingRotation(false);
		}).catch((e) => {
			console.error(e);
			snack('Failed to save image', 'error');
			setIsSavingRotation(false);
		});
	};

	const checkinOutImages = useMemo(() => {
		const images = [];
		const checkinSrc = checkinImageOverrides.checkin_image || checkinData?.checkin_image;
		const checkoutSrc = checkinImageOverrides.checkout_image || checkinData?.checkout_image;
		if (checkinSrc) {
			images.push({ upload_image: checkinSrc, upload_id: checkinData?.checkin_image_id });
		}
		if (checkoutSrc) {
			images.push({ upload_image: checkoutSrc, upload_id: checkinData?.checkout_image_id });
		}
		return images;
	}, [checkinData?.checkin_image, checkinData?.checkout_image, checkinData?.checkin_image_id, checkinData?.checkout_image_id, checkinImageOverrides]);

	const handleSelectAttachmentImage = (item) => {
		const idx = attachments.findIndex(a => a.upload_id === item.upload_id);
		setSelectedImage(item);
		setImageGroup('attachment');
		setImageIndex(idx >= 0 ? idx : 0);
	};

	const handleSelectCheckinImage = (item) => {
		const idx = checkinOutImages.findIndex(a => a.upload_id === item.upload_id);
		setSelectedImage(item);
		setImageGroup('checkin');
		setImageIndex(idx >= 0 ? idx : 0);
	};

	const handlePrevImage = () => {
		const group = imageGroup === 'attachment' ? attachments : checkinOutImages;
		if (imageIndex > 0) {
			const newIndex = imageIndex - 1;
			setSelectedImage(group[newIndex]);
			setImageIndex(newIndex);
			setImageZoom(1);
			setImagePosition({ x: 0, y: 0 });
			setImageRotation(0);
		}
	};

	const handleNextImage = () => {
		const group = imageGroup === 'attachment' ? attachments : checkinOutImages;
		if (imageIndex < group.length - 1) {
			const newIndex = imageIndex + 1;
			setSelectedImage(group[newIndex]);
			setImageIndex(newIndex);
			setImageZoom(1);
			setImagePosition({ x: 0, y: 0 });
			setImageRotation(0);
		}
	};

	const currentGroupImages = imageGroup === 'attachment' ? attachments : checkinOutImages;
	const canNavigate = currentGroupImages && currentGroupImages.length > 1;
	const canGoPrev = imageIndex > 0;
	const canGoNext = currentGroupImages && imageIndex < currentGroupImages.length - 1;

	const latlongList = [{
		title: 'CHECK-IN',
		loc: [checkinData?.location_lng || 0, checkinData?.location_lat || 0]
	}, { title: 'CHECK-OUT', loc: [checkinData?.checkout_lng || 0, checkinData?.checkout_lat || 0] }];
	// const attachements = checkinData?.uploads || [];

	const displayableScheduleFields = ['sched_datetime', 'sched_note', 'site_in_charge', 'site_in_charge_contact', 'tags', 'project_no'];
	const hasSched = checkinData && 'schedule' in checkinData &&
		Object.keys(checkinData?.schedule || {}).some(key => displayableScheduleFields.includes(key));

	const approve = (checkinID, salespersonID, outletName, outletAddr) => {
		setApproveCheckinID(approveCheckinID => (checkinID));
		setApproveSalespersonID(approveSalespersonID => (salespersonID));
		setApproveOutletName(approveOutletName => (outletName));
		setApproveOutletAddr(approveOutletAddr => (outletAddr));
		let formData = new FormData();
		formData.append('checkin_id', checkinID);
		formData.append('salesperson', salespersonID);
		formData.append('cust_company_name', outletName);
		formData.append('billing_address1', outletAddr);
		API_Service.post(req_cust_approve, formData, axiosApiConfig).then(({ data }) => {
			const { result, message, extraData } = data;
			if (result) {
				setClose();
				snack(language.insert_success);
			} else {
				snack(message, 'warning');
			}
		});
	}

	const reject = (checkinID, salespersonID) => {
		setApproveCheckinID(approveCheckinID => (checkinID));
		setApproveSalespersonID(approveSalespersonID => (salespersonID));
		setCView(true);
	}

	const cViewClose = (newValue) => {
		setCView(false);
		if (newValue.value != 'RESET') {
			var params = {
				checkin_id: approveCheckinID,
				salesperson_id: approveSalespersonID,
				cust_code: newValue.value
			};
			params = axiosURIencode(params);
			API_Service.put(req_cust_approve, params, axiosApiConfig).then(({ data }) => {
				const { result, message } = data;
				if (result == 1) {
					setClose();
					snack(language.update_success);
				} else {
					snack(message, 'warning');
				}
			});
		}
	}

	return (
		<div className={classes.root}>
			<Dialog
				fullScreen
				open={open}
				onClose={() => closeDialog()}
				TransitionComponent={Transition}
				classes={{ paper: classes.scrollableContent }}
			>
				<AppBar className={classes.appBar}>
					<Toolbar>
						<IconButton edge="start" color="inherit" onClick={() => closeDialog()} aria-label="close">
							<CloseIcon />
						</IconButton>
						<Typography variant="h6" className={classes.title}>
							{currentPage === 0 ? language.checkin_dtl : currentPage === 1 ? language.stock_take : language.stock_transfer}
						</Typography>
					</Toolbar>
				</AppBar>
				{
					currentPage === 0 && (
						<div>
							{(() => {
								const hasImages = attachments && attachments.length > 0;
								const isManyImages = attachments && attachments.length > 4;

								if (!hasImages) {
									// 1. No Images
									return (
										<Grid container spacing={3} className={classes.grid}>
											<Grid item xs={12}>
												<Paper className={classes.paper}>
													<CheckinInfoSection checkinData={checkinData} classes={classes} setSelectedImage={handleSelectCheckinImage} checkinImageOverrides={checkinImageOverrides} />
												</Paper>
											</Grid>
											{hasSched && (
												<Grid item xs={12}>
													<Paper className={classes.paper}>
														<ScheduleInfoSection checkinData={checkinData} classes={classes} />
													</Paper>
												</Grid>
											)}
											<Grid item xs={12}>
												<Paper className={classes.paper}>
													<ImagesSection
														attachments={attachments}
														classes={classes}
														paperStyle={paperStyle}
														setSelectedImage={handleSelectAttachmentImage}
														hasSched={false}
														onUploadClick={() => setUploadDialogOpen(true)}
														language={language}
													/>
												</Paper>
											</Grid>
											<Grid item xs={12}>
												<Paper className={classes.paper}>
													<CheckinMap checkinData={checkinData} />
												</Paper>
											</Grid>
										</Grid>
									);
								} else if (isManyImages) {
									// 3. Many Images (> 4)
									return (
										<Grid container spacing={3} className={classes.grid}>
											<Grid item xs={9}>
												<Grid container spacing={3}>
													<Grid item xs={12}>
														<Paper className={classes.paper}>
															<CheckinInfoSection checkinData={checkinData} classes={classes} setSelectedImage={handleSelectCheckinImage} checkinImageOverrides={checkinImageOverrides} />
														</Paper>
													</Grid>
													{hasSched && (
														<Grid item xs={12}>
															<Paper className={classes.paper}>
																<ScheduleInfoSection checkinData={checkinData} classes={classes} />
															</Paper>
														</Grid>
													)}
													<Grid item xs={12}>
														<Paper className={classes.paper}>
															<CheckinMap checkinData={checkinData} />
														</Paper>
													</Grid>
												</Grid>
											</Grid>
											<Grid item xs={3}>
												<Paper className={`${classes.paper} ${classes.scrollableContent}`} style={{ maxHeight: '1295px', overflowY: 'auto' }}>
													<ImagesSection
														attachments={attachments}
														classes={classes}
														paperStyle={paperStyle}
														setSelectedImage={handleSelectAttachmentImage}
														hasSched={false}
														onUploadClick={() => setUploadDialogOpen(true)}
														language={language}
													/>
												</Paper>
											</Grid>
										</Grid>
									);
								} else {
									// 2. Few Images (1-4)
									return (
										<Grid container spacing={3} className={classes.grid}>
											<Grid item xs={8}>
												<Paper className={classes.paper}>
													<CheckinInfoSection checkinData={checkinData} classes={classes} setSelectedImage={handleSelectCheckinImage} checkinImageOverrides={checkinImageOverrides} />
												</Paper>
												{hasSched && (
													<Paper className={classes.paper} style={{ marginTop: theme.spacing(3) }}>
														<ScheduleInfoSection checkinData={checkinData} classes={classes} />
													</Paper>
												)}
											</Grid>
											<Grid item xs={4}>
												<Paper className={`${classes.paper} ${classes.scrollableContent}`} style={{ height: '100%', overflowY: 'auto' }}>
													<ImagesSection
														attachments={attachments}
														classes={classes}
														paperStyle={paperStyle}
														setSelectedImage={handleSelectAttachmentImage}
														hasSched={false}
														onUploadClick={() => setUploadDialogOpen(true)}
														language={language}
													/>
												</Paper>
											</Grid>
											<Grid item xs={12}>
												<Paper className={classes.paper}>
													<CheckinMap checkinData={checkinData} />
												</Paper>
											</Grid>
										</Grid>
									);
								}
							})()}
							{
								selectedImage && (
									<Dialog
										fullWidth={true}
										maxWidth={'lg'}
										open={selectedImage != null}
										aria-labelledby="form-dialog-title"
										onClose={() => {
											setSelectedImage(null);
											setImageZoom(1);
											setImagePosition({ x: 0, y: 0 });
											setImageRotation(0);
											setImageGroup(null);
											setImageIndex(0);
										}}>
										<DialogContent style={{
											height: '85vh',
											display: 'flex',
											flexDirection: 'column',
											padding: 0,
											overflow: 'hidden',
											position: 'relative'
										}}>
											{selectedImage && (
												<>
													{/* Image Container */}
													<div style={{
														flex: 1,
														display: 'flex',
														justifyContent: 'center',
														alignItems: 'center',
														overflow: 'hidden',
														backgroundColor: '#000',
														position: 'relative'
													}}>
														<img
															src={selectedImage.upload_image}
															alt="Checkin"
															onMouseDown={handleMouseDown}
															style={{
																maxWidth: '800px',
																maxHeight: '100%',
																width: 'auto',
																height: 'auto',
																objectFit: 'contain',
																transform: `translate(${imagePosition.x}px, ${imagePosition.y}px) rotate(${imageRotation}deg) scale(${imageZoom})`,
																transformOrigin: 'center center',
																transition: isDragging ? 'none' : 'transform 0.2s ease-out',
																userSelect: 'none',
																cursor: imageZoom > 1 ? (isDragging ? 'grabbing' : 'grab') : 'default'
															}}
														/>

														{/* æ“ä½œæç¤º */}
														{imageZoom > 1 && !isDragging && (
															<div style={{
																position: 'absolute',
																top: '20px',
																left: '20px',
																backgroundColor: 'rgba(0,0,0,0.7)',
																color: 'white',
																padding: '8px 12px',
																borderRadius: '6px',
																fontSize: '14px',
																fontWeight: '500',
																pointerEvents: 'none',
																opacity: 0.8,
																zIndex: 10
															}}>
																Drag to move or use direction controls
															</div>
														)}

														{/* Image Navigation Arrows */}
														{canNavigate && (
															<>
																<IconButton
																	onClick={handlePrevImage}
																	disabled={!canGoPrev}
																	style={{
																		position: 'absolute',
																		left: 16,
																		top: '50%',
																		transform: 'translateY(-50%)',
																		backgroundColor: canGoPrev ? 'rgba(0,0,0,0.5)' : 'rgba(0,0,0,0.2)',
																		color: canGoPrev ? '#fff' : 'rgba(255,255,255,0.3)',
																		zIndex: 10,
																		width: 44,
																		height: 44,
																	}}
																>
																	<ArrowBackIcon />
																</IconButton>
																<IconButton
																	onClick={handleNextImage}
																	disabled={!canGoNext}
																	style={{
																		position: 'absolute',
																		right: 16,
																		top: '50%',
																		transform: 'translateY(-50%)',
																		backgroundColor: canGoNext ? 'rgba(0,0,0,0.5)' : 'rgba(0,0,0,0.2)',
																		color: canGoNext ? '#fff' : 'rgba(255,255,255,0.3)',
																		zIndex: 10,
																		width: 44,
																		height: 44,
																	}}
																>
																	<ArrowForwardIcon />
																</IconButton>
																<div style={{
																	position: 'absolute',
																	top: 16,
																	right: 16,
																	backgroundColor: 'rgba(0,0,0,0.6)',
																	color: '#fff',
																	padding: '4px 12px',
																	borderRadius: 20,
																	fontSize: 13,
																	fontWeight: 600,
																	zIndex: 10,
																	letterSpacing: '0.5px',
																}}>
																	{imageIndex + 1} / {currentGroupImages.length}
																</div>
															</>
														)}
													</div>

													{/* Control Bar */}
													<div style={{
														display: 'flex',
														justifyContent: 'center',
														alignItems: 'center',
														padding: '14px 24px',
														backgroundColor: '#FEF200',
														borderTop: 'none',
														gap: '12px',
														boxShadow: '0 -4px 20px rgba(0,0,0,0.08)'
													}}>
														{/* Zoom Controls Group */}
														<div style={{
															display: 'flex',
															alignItems: 'center',
															backgroundColor: 'rgba(255,255,255,0.95)',
															borderRadius: '12px',
															padding: '6px 8px',
															boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
															gap: '2px'
														}}>
															<IconButton
																onClick={() => {
																	const newZoom = Math.max(1, imageZoom - 0.1);
																	setImageZoom(newZoom);
																	if (newZoom === 1) {
																		setImagePosition({ x: 0, y: 0 });
																	}
																}}
																disabled={imageZoom <= 1}
																style={{
																	backgroundColor: imageZoom > 1 ? '#f0f0f0' : 'transparent',
																	width: '34px',
																	height: '34px',
																	borderRadius: '8px',
																	transition: 'all 0.15s ease'
																}}
															>
																<Typography style={{
																	fontSize: '18px',
																	fontWeight: '600',
																	color: imageZoom > 1 ? '#1a1a1a' : '#aaa',
																	lineHeight: 1
																}}>
																	-
																</Typography>
															</IconButton>

															<div style={{
																minWidth: '64px',
																padding: '4px 8px',
																textAlign: 'center'
															}}>
																<Typography
																	style={{
																		fontWeight: '700',
																		color: '#1a1a1a',
																		fontSize: '13px',
																		letterSpacing: '-0.3px'
																	}}
																>
																	{Math.round(imageZoom * 100)}%
																</Typography>
															</div>

															<IconButton
																onClick={() => {
																	setImageZoom(Math.min(5, imageZoom + 0.1));
																}}
																disabled={imageZoom >= 5}
																style={{
																	backgroundColor: imageZoom < 5 ? '#f0f0f0' : 'transparent',
																	width: '34px',
																	height: '34px',
																	borderRadius: '8px',
																	transition: 'all 0.15s ease'
																}}
															>
																<Typography style={{
																	fontSize: '18px',
																	fontWeight: '600',
																	color: imageZoom < 5 ? '#1a1a1a' : '#aaa',
																	lineHeight: 1
																}}>
																	+
																</Typography>
															</IconButton>
														</div>

														{/* Direction Controls Group */}
														<div style={{
															display: 'flex',
															alignItems: 'center',
															backgroundColor: 'rgba(255,255,255,0.95)',
															borderRadius: '12px',
															padding: '6px',
															boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
														}}>
															<div style={{
																display: 'grid',
																gridTemplateColumns: 'repeat(3, 30px)',
																gap: '2px'
															}}>
																{/* Top Left */}
																<div />

																{/* Top Center */}
																<IconButton
																	onClick={() => {
																		setImagePosition({
																			x: imagePosition.x,
																			y: imagePosition.y + 50
																		});
																	}}
																	disabled={imageZoom <= 1}
																	style={{
																		backgroundColor: imageZoom > 1 ? '#f0f0f0' : 'transparent',
																		width: '30px',
																		height: '30px',
																		borderRadius: '6px',
																		padding: 0,
																		transition: 'all 0.15s ease'
																	}}
																>
																	<ArrowUpwardIcon style={{
																		fontSize: '16px',
																		color: imageZoom > 1 ? '#1a1a1a' : '#aaa'
																	}} />
																</IconButton>

																{/* Top Right */}
																<div />

																{/* Middle Left */}
																<IconButton
																	onClick={() => {
																		setImagePosition({
																			x: imagePosition.x + 50,
																			y: imagePosition.y
																		});
																	}}
																	disabled={imageZoom <= 1}
																	style={{
																		backgroundColor: imageZoom > 1 ? '#f0f0f0' : 'transparent',
																		width: '30px',
																		height: '30px',
																		borderRadius: '6px',
																		padding: 0,
																		transition: 'all 0.15s ease'
																	}}
																>
																	<ArrowBackIcon style={{
																		fontSize: '16px',
																		color: imageZoom > 1 ? '#1a1a1a' : '#aaa'
																	}} />
																</IconButton>

																{/* Middle Center */}
																<IconButton
																	onClick={() => {
																		setImagePosition({
																			x: imagePosition.x,
																			y: imagePosition.y - 50
																		});
																	}}
																	disabled={imageZoom <= 1}
																	style={{
																		backgroundColor: imageZoom > 1 ? '#f0f0f0' : 'transparent',
																		width: '30px',
																		height: '30px',
																		borderRadius: '6px',
																		padding: 0,
																		transition: 'all 0.15s ease'
																	}}
																>
																	<ArrowDownwardIcon style={{
																		fontSize: '16px',
																		color: imageZoom > 1 ? '#1a1a1a' : '#aaa'
																	}} />
																</IconButton>

																{/* Middle Right */}
																<IconButton
																	onClick={() => {
																		setImagePosition({
																			x: imagePosition.x - 50,
																			y: imagePosition.y
																		});
																	}}
																	disabled={imageZoom <= 1}
																	style={{
																		backgroundColor: imageZoom > 1 ? '#f0f0f0' : 'transparent',
																		width: '30px',
																		height: '30px',
																		borderRadius: '6px',
																		padding: 0,
																		transition: 'all 0.15s ease'
																	}}
																>
																	<ArrowForwardIcon style={{
																		fontSize: '16px',
																		color: imageZoom > 1 ? '#1a1a1a' : '#aaa'
																	}} />
																</IconButton>
															</div>
														</div>

														{/* Rotation Controls Group */}
														<div style={{
															display: 'flex',
															alignItems: 'center',
															backgroundColor: 'rgba(255,255,255,0.95)',
															borderRadius: '12px',
															padding: '6px 8px',
															boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
															gap: '2px'
														}}>
															<IconButton
																onClick={() => {
																	setImageRotation((imageRotation - 90) % 360);
																}}
																style={{
																	backgroundColor: '#f0f0f0',
																	width: '34px',
																	height: '34px',
																	borderRadius: '8px',
																	transition: 'all 0.15s ease'
																}}
															>
																<RotateLeftIcon style={{
																	fontSize: '17px',
																	color: '#1a1a1a'
																}} />
															</IconButton>

															<div style={{
																minWidth: '48px',
																padding: '4px 6px',
																textAlign: 'center'
															}}>
																<Typography
																	style={{
																		fontWeight: '700',
																		color: '#1a1a1a',
																		fontSize: '12px',
																		letterSpacing: '-0.2px'
																	}}
																>
																	{((imageRotation % 360 + 360) % 360)}°
																</Typography>
															</div>

															<IconButton
																onClick={() => {
																	setImageRotation((imageRotation + 90) % 360);
																}}
																style={{
																	backgroundColor: '#f0f0f0',
																	width: '34px',
																	height: '34px',
																	borderRadius: '8px',
																	transition: 'all 0.15s ease'
																}}
															>
																<RotateRightIcon style={{
																	fontSize: '17px',
																	color: '#1a1a1a'
																}} />
															</IconButton>
														</div>

														{/* Reset Button */}
														<IconButton
															onClick={() => {
																setImageZoom(1);
																setImagePosition({ x: 0, y: 0 });
																setImageRotation(0);
															}}
															disabled={imageZoom === 1 && imagePosition.x === 0 && imagePosition.y === 0 && imageRotation === 0}
															style={{
																backgroundColor: (imageZoom !== 1 || imagePosition.x !== 0 || imagePosition.y !== 0 || imageRotation !== 0)
																	? 'rgba(26,26,26,0.9)'
																	: 'rgba(255,255,255,0.6)',
																padding: '8px 18px',
																borderRadius: '10px',
																transition: 'all 0.2s ease',
																boxShadow: (imageZoom !== 1 || imagePosition.x !== 0 || imagePosition.y !== 0 || imageRotation !== 0)
																	? '0 2px 8px rgba(0,0,0,0.12)'
																	: 'none'
															}}
														>
															<Typography
																style={{
																	color: (imageZoom !== 1 || imagePosition.x !== 0 || imagePosition.y !== 0 || imageRotation !== 0)
																		? '#fff'
																		: '#999',
																	fontWeight: '600',
																	fontSize: '13px',
																	letterSpacing: '0.2px'
																}}
															>
																Reset
															</Typography>
														</IconButton>

														{/* Save Rotation Button */}
														<IconButton
															onClick={handleSaveRotation}
															disabled={imageRotation === 0 || isSavingRotation}
															style={{
																backgroundColor: (imageRotation !== 0 && !isSavingRotation)
																	? 'rgba(102,187,106,0.9)'
																	: 'rgba(255,255,255,0.6)',
																padding: '8px 18px',
																borderRadius: '10px',
																transition: 'all 0.2s ease',
																boxShadow: (imageRotation !== 0)
																	? '0 2px 8px rgba(102,187,106,0.25)'
																	: 'none'
															}}
														>
															<Typography
																style={{
																	color: (imageRotation !== 0 && !isSavingRotation)
																		? '#fff'
																		: '#999',
																	fontWeight: '600',
																	fontSize: '13px',
																	letterSpacing: '0.2px'
																}}
															>
																{isSavingRotation ? 'Saving...' : 'Save'}
															</Typography>
														</IconButton>
													</div>
												</>
											)}
										</DialogContent>
									</Dialog>
								)
							}
							{
								// checkinData && (
								// 	<RenderMap
								// 		lightTheme={lightTheme}
								// 		latlongList={latlongList}
								// 		userLocations={userLocations}
								// 	/>
								// )
							}
						</div>
					)
				}
				{
					currentPage === 1 && (
						<div>
							<Tabs
								variant="fullWidth"
								value={currentST}
								indicatorColor="primary"
								textColor="primary"
								onChange={(event, newValue) => {
									setCurrentST(newValue);
								}}
								aria-label="nav tabs example">
								<LinkTab label={language.inapp_doc} />
								{/* <LinkTab label={language.confirmed_doc}/> */}
								{/* <LinkTab label={language.trans_doc}/> */}
								{/* <LinkTab label={language.posted_doc}/> */}
							</Tabs>
							{
								currentST === 0 && (
									<MUIDataTable
										title={checkinData?.mobile_checkin_id ? checkinData.mobile_checkin_id : ''}
										data={appSTList}
										columns={headCells}
										options={{
											print: false,
											filter: true,
											selectableRows: appSTList?.length > 0 ? 'multiple' : 'none',
											rowsSelected: appSTList?.length > 0 ? undefined : [],
											rowsPerPage: 10,
											rowsPerPageOptions: [10],
											responsive: 'simple',
											onRowClick: (rowData) => {
												// de("betty-rowData", rowData);
												setSTToView(rowData[0]);
												toggleDocDetails(true);
											},
											customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {
												const data = selectedRows?.data;
												return (
													<div style={{ marginRight: 25 }}>
														<ToolbarCustomSelect
															title={'Transfer'}
															onClick={() => {
																toggleDocStatus(data, 'active', 1)
															}}
														>
															<SendIcon />
														</ToolbarCustomSelect>
														<ToolbarCustomSelect
															title={'Delete'}
															onClick={() => {
																toggleDocCancel(data, 'active')
															}}
														>
															<DeleteIcon />
														</ToolbarCustomSelect>
													</div>
												)
											},
										}}
									/>
								)
							}
							{
								currentST === 1 && (
									<MUIDataTable
										title={language.stock_take}
										data={conSTList}
										columns={headCells}
										options={{
											print: false,
											filter: true,
											selectableRows: conSTList?.length > 0 ? 'multiple' : 'none',
											rowsSelected: conSTList?.length > 0 ? undefined : [],
											rowsPerPage: 10,
											rowsPerPageOptions: [10],
											responsive: 'simple',
											onRowClick: (rowData) => {
												setSTToView(rowData[0]);
												toggleDocDetails(true)
											},
											customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {
												const data = selectedRows?.data;
												return (
													<div style={{ marginRight: 25 }}>
														<ToolbarCustomSelect
															title={'Transfer'}
															onClick={() => {
																toggleDocStatus(data, 'confirmed', 2)
															}}
														>
															<SendIcon />
														</ToolbarCustomSelect>
														<ToolbarCustomSelect
															title={'Delete'}
															onClick={() => {
																toggleDocCancel(data, 'confirmed')
															}}
														>
															<DeleteIcon />
														</ToolbarCustomSelect>
													</div>
												)
											},
										}}
									/>
								)
							}
							{
								currentST === 2 && (
									<MUIDataTable
										title={language.stock_take}
										data={transSTList}
										columns={headCells}
										options={{
											print: false,
											filter: true,
											selectableRows: transSTList?.length > 0 ? 'multiple' : 'none',
											rowsSelected: transSTList?.length > 0 ? undefined : [],
											rowsPerPage: 10,
											rowsPerPageOptions: [10],
											responsive: 'simple',
											onRowClick: (rowData) => {
												setSTToView(rowData[0]);
												toggleDocDetails(true)
											},
											customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {
												const data = selectedRows?.data;
												return (
													<div style={{ marginRight: 25 }}>
														<ToolbarCustomSelect
															title={'Transfer'}
															onClick={() => {
																toggleDocStatus(data, 'transferred', 3)
															}}
														>
															<SendIcon />
														</ToolbarCustomSelect>
													</div>
												)
											},
										}}
									/>
								)
							}
							{
								currentST === 3 && (
									<MUIDataTable
										title={language.stock_take}
										data={postSTList}
										columns={headCells}
										options={{
											print: false,
											filter: true,
											selectableRows: 'none',
											rowsPerPage: 10,
											rowsPerPageOptions: [10],
											responsive: 'simple',
											onRowClick: (rowData) => {
												setSTToView(rowData[0]);
												toggleDocDetails(true)
											}
										}}
									/>
								)
							}
						</div>
					)
				}
				{
					sTransInclude === '1' && (
						currentPage === 2 && (
							<div>
								<Tabs
									variant="fullWidth"
									value={currentSTrans}
									indicatorColor="primary"
									textColor="primary"
									onChange={(event, newValue) => {
										setCurrentSTrans(newValue);
									}}
									aria-label="nav tabs example">
									<LinkTab label={language.inapp_doc} />
									<LinkTab label={language.confirmed_doc} />
									<LinkTab label={language.trans_doc} />
									<LinkTab label={language.posted_doc} />
								</Tabs>
								{
									currentSTrans === 0 && (
										<MUIDataTable
											title={language.stock_transfer}
											data={appSTransList}
											columns={transferheadCells}
											options={{
												print: false,
												filter: true,
												selectableRows: appSTransList?.length > 0 ? 'multiple' : 'none',
												rowsSelected: appSTransList?.length > 0 ? undefined : [],
												rowsPerPage: 10,
												rowsPerPageOptions: [10],
												responsive: 'simple',
												onRowClick: () => {
													toggleTransDocDetails(true)
												},
												customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {
													const data = selectedRows?.data;
													return (
														<div style={{ marginRight: 25 }}>
															<ToolbarCustomSelect
																title={'Transfer'}
																onClick={() => {
																	toggleTransferDocStatus(data, 'active', 1)
																}}
															>
																<SendIcon />
															</ToolbarCustomSelect>
															<ToolbarCustomSelect
																title={'Delete'}
																onClick={() => {
																	toggleTranserDocCancel(data, 'active')
																}}
															>
																<DeleteIcon />
															</ToolbarCustomSelect>
														</div>
													)
												},
											}}
										/>
									)
								}
								{
									currentSTrans === 1 && (
										<MUIDataTable
											title={language.stock_transfer}
											data={conSTransList}
											columns={transferheadCells}
											options={{
												print: false,
												filter: true,
												selectableRows: conSTransList?.length > 0 ? 'multiple' : 'none',
												rowsSelected: conSTransList?.length > 0 ? undefined : [],
												rowsPerPage: 10,
												rowsPerPageOptions: [10],
												responsive: 'simple',
												onRowClick: () => {
													toggleTransDocDetails(true)
												},
												customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {
													const data = selectedRows?.data;
													return (
														<div style={{ marginRight: 25 }}>
															<ToolbarCustomSelect
																title={'Transfer'}
																onClick={() => {
																	toggleTransferDocStatus(data, 'confirmed', 2)
																}}
															>
																<SendIcon />
															</ToolbarCustomSelect>
															<ToolbarCustomSelect
																title={'Delete'}
																onClick={() => {
																	toggleTranserDocCancel(data, 'confirmed')
																}}
															>
																<DeleteIcon />
															</ToolbarCustomSelect>
														</div>
													)
												},
											}}
										/>
									)
								}
								{
									currentSTrans === 2 && (
										<MUIDataTable
											title={language.stock_transfer}
											data={transSTransList}
											columns={transferheadCells}
											options={{
												print: false,
												filter: true,
												selectableRows: transSTransList?.length > 0 ? 'multiple' : 'none',
												rowsSelected: transSTransList?.length > 0 ? undefined : [],
												rowsPerPage: 10,
												rowsPerPageOptions: [10],
												responsive: 'simple',
												onRowClick: () => {
													toggleTransDocDetails(true)
												},
												customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {
													const data = selectedRows?.data;
													return (
														<div style={{ marginRight: 25 }}>
															<ToolbarCustomSelect
																title={'Transfer'}
																onClick={() => {
																	toggleTransferDocStatus(data, 'transferred', 3)
																}}
															>
																<SendIcon />
															</ToolbarCustomSelect>
														</div>
													)
												},
											}}
										/>
									)
								}
								{
									currentSTrans === 3 && (
										<MUIDataTable
											title={language.stock_transfer}
											data={postSTransList}
											columns={transferheadCells}
											options={{
												print: false,
												filter: true,
												selectableRows: 'none',
												rowsPerPage: 10,
												rowsPerPageOptions: [10],
												responsive: 'simple',
												onRowClick: () => {
													toggleTransDocDetails(true)
												}
											}}
										/>
									)
								}
							</div>
						)
					)
				}

				<StockTakeDetails
					open={showDocDetails}
					setClose={() => toggleDocDetails((false))}
					language={language}
					stockTakeID={stToView}
					axiosConfig={axiosApiConfig}
					username={current_username}
				/>
				{/* <StockTransferDetails
					open={showTransDocDetails}
					setClose={() => toggleTransDocDetails(showDocDetails => (false))}
					language={language}
					itemList={checkinData?.transfer_dtl}
					docDtl={checkinData?.transfer_id}
					axiosConfig={axiosApiConfig}
					doctype={'transfer'}
					snack={snack}
					ToolbarCustomSelect={ToolbarCustomSelect}
				/> */}
				<BottomNavigation
					value={currentPage}
					onChange={(event, newValue) => {
						setCurrentPage(newValue);
					}}
					showLabels
					className={commonStyles.bottomNav}>
					<BottomNavigationAction label="CheckIn Details" />
					<BottomNavigationAction label="Stock Take" />
					{
						sTransInclude === '1' && (
							<BottomNavigationAction label="Stock Transfer" />
						)
					}
				</BottomNavigation>
			</Dialog>

			<VirtualList
				open={cView}
				setClose={data => cViewClose(data)}
				title={language.cust_list}
				data={customerList}
				language={language}
			/>

			<Dialog
				open={uploadDialogOpen}
				onClose={function () {
					if (!isUploading) {
						setUploadDialogOpen(false);
						setUploadFiles([]);
						setSelectedCategories([]);
					}
				}}
				fullWidth
				maxWidth="md"
				PaperProps={{ style: { borderRadius: 12, overflow: 'hidden' } }}
			>
				{/* Header */}
				<div className={classes.uploadDialogHeader}>
					<div className={classes.sectionAccent} />
					<Typography variant="h6" style={{ fontWeight: 700, fontSize: 15, letterSpacing: '0.02em' }}>
						{language.upload_photo}
					</Typography>
					<span className={classes.uploadFileBadge}>{uploadFiles.length} / 10</span>
					<IconButton
						style={{ marginLeft: 'auto' }}
						size="small"
						onClick={function () {
							if (!isUploading) {
								setUploadDialogOpen(false);
								setUploadFiles([]);
								setSelectedCategories([]);
							}
						}}
					>
						<CloseIcon fontSize="small" />
					</IconButton>
				</div>

				{/* Content: Side by Side */}
				<div className={classes.uploadDialogContent}>
					{/* Left: Drop Zone + Preview */}
					<div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 12 }}>
						<div
							className={`${classes.uploadDropZone} ${isDragOver ? classes.uploadDropZoneHover : ''}`}
							onDrop={handleDrop}
							onDragOver={handleDragOver}
							onDragLeave={handleDragLeave}
							onClick={function () { if (fileInputRef.current) fileInputRef.current.click(); }}
						>
							<input
								ref={fileInputRef}
								type="file"
								accept="image/jpeg,image/png,image/jpg,image/webp"
								multiple
								style={{ display: 'none' }}
								onChange={function (e) { if (e.target.files) addFiles(e.target.files); e.target.value = ''; }}
							/>
							<div className={classes.uploadDropZoneIcon}>
								<AddPhotoAlternateIcon style={{ color: '#FEF200', fontSize: 24 }} />
							</div>
							<Typography variant="body2" style={{ color: 'rgba(255,255,255,0.7)', fontWeight: 500 }}>
								{language.upload_photo}
							</Typography>
							<Typography variant="caption" style={{ color: 'rgba(255,255,255,0.35)', marginTop: 6 }}>
								JPG, PNG, WEBP (max 10MB)
							</Typography>
						</div>

						{uploadFiles.length > 0 && (
							<div className={classes.uploadPreviewGrid}>
								{uploadPreviews.map(function (url, idx) {
									return (
										<div key={String(idx)} className={classes.uploadPreviewItem}>
											<img src={url} alt="" className={classes.uploadPreviewImg} />
											<div className={classes.uploadDeleteBadge} onClick={function (e) { e.stopPropagation(); removeFile(idx); }}>x</div>
										</div>
									);
								})}
								{uploadFiles.length < 10 && (
									<div className={classes.uploadAddMore} onClick={function () { if (fileInputRef.current) fileInputRef.current.click(); }}>+</div>
								)}
							</div>
						)}
					</div>

					{/* Divider */}
					<div className={classes.uploadDivider} />

					{/* Right: Category + Actions */}
					<div className={classes.uploadRightPanel}>
						<div>
							<div className={classes.uploadCategoryLabel}>
								{language.select_photo_category} <span style={{ color: '#FEF200' }}>*</span>
							</div>
							<div
								className={classes.uploadCategorySelector}
								onClick={function () { setCategoryViewOpen(true); }}
							>
								<span style={{ fontSize: 13, color: 'rgba(255,255,255,0.5)' }}>
									{selectedCategories.length > 0
										? selectedCategories.length + ' ' + language.photo_type
										: language.select_photo_category
									}
								</span>
								<ExpandMoreIcon style={{ fontSize: 16, color: 'rgba(255,255,255,0.3)' }} />
							</div>
						</div>

						{selectedCategories.length > 0 && (
							<div className={classes.uploadChipContainer}>
								{selectedCategories.map(function (cat, idx) {
									return (
										<Chip
											key={String(idx)}
											label={cat.name}
											className={classes.uploadChip}
											size="small"
											onDelete={function () {
												setSelectedCategories(function (prev) { return prev.filter(function (_, i) { return i !== idx; }); });
											}}
										/>
									);
								})}
							</div>
						)}

						<div style={{ flex: 1 }} />

						<div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
							<Button
								className={classes.uploadCancelBtn}
								onClick={function () {
									setUploadDialogOpen(false);
									setUploadFiles([]);
									setSelectedCategories([]);
								}}
								disabled={isUploading}
							>
								{language.cancel}
							</Button>
							<Button
								className={classes.uploadSaveBtn}
								onClick={handleUploadSave}
								disabled={isUploading || uploadFiles.length === 0 || selectedCategories.length === 0}
							>
								{isUploading
									? <CircularProgress size={20} style={{ color: '#1a1a1a' }} />
									: language.save
								}
							</Button>
						</div>
					</div>
				</div>
			</Dialog>

			<VirtualListHierarchical
				open={categoryViewOpen}
				setClose={onCategorySelected}
				title={language.photo_type}
				data={categoryList}
				language={language}
				filteration={1}
				selected={selectedCategories}
				enabledCheckAll={true}
			/>
		</div>
	)
}

export function ToolbarCustomSelect({ onClick, title, children, disabled = false }) {
	return (
		<React.Fragment>
			<Tooltip title={title}>
				<IconButton disabled={disabled} onClick={() => onClick()}>
					{children}
				</IconButton>
			</Tooltip>
		</React.Fragment>
	)
}



function LinkTab(props) {
	return (
		<Tab
			component="a"
			onClick={(event) => {
				event.preventDefault();
			}}
			{...props}
		/>
	);
}


